import { render, staticRenderFns } from "./protocolInfo.vue?vue&type=template&id=65ad59d8&scoped=true&"
import script from "./protocolInfo.vue?vue&type=script&lang=js&"
export * from "./protocolInfo.vue?vue&type=script&lang=js&"
import style0 from "./protocolInfo.vue?vue&type=style&index=0&id=65ad59d8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ad59d8",
  null
  
)

export default component.exports